<template>
  <div class="flex flex-col gap-2">
    <div v-if="googleHighlight" class="flex flex-wrap gap-2">
      <div class="h-6 flex items-center gap-1 px-2 bg-orange-50 rounded">
        <svg-icon name="fire" color="white" />
        <span class="text-xs text-white">{{ googleHighlight.label }}</span>
      </div>

      <div class="h-6 flex items-center gap-2 px-2 bg-gray-20 rounded">
        <svg-icon name="google-login" class="size-3" />
        <span class="text-xs text-gray-80">{{ $t('ai.google.rating', { rating: googleHighlight.rating }) }}</span>
      </div>
    </div>

    <ul class="flex flex-col gap-2">
      <li v-for="item in summaryItems" :key="item.labelKey" class="flex items-start">
        <svg-icon name="shiny" class="size-6" />
        <p>
          <span class="font-700">{{ $t(item.labelKey) }}</span
          >{{ item.description }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { BranchReviewSummaryItem, BranchReviewHighlightItem } from '@/types/api'

interface SummaryItem {
  labelKey: string
  description?: string
}

interface Props {
  googleHighlight?: BranchReviewHighlightItem
  productUsp?: BranchReviewSummaryItem
  vibeService?: BranchReviewSummaryItem
}

const props = defineProps<Props>()

const summaryItems = computed(() => {
  const items: SummaryItem[] = []
  if (props.productUsp) items.push({ labelKey: 'ai.google.subtitle1', description: props.productUsp.description })
  if (props.vibeService) items.push({ labelKey: 'ai.google.subtitle2', description: props.vibeService.description })
  return items
})
</script>
